var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.0356 6.2636a.9.9 0 0 1 0 1.2728l-11.4 11.4a.9.9 0 0 1-1.2728 0l-5.4-5.4a.9.9 0 0 1 1.2728-1.2728l4.7636 4.7636L19.7628 6.2636a.9.9 0 0 1 1.2728 0Z",
  clipRule: "evenodd"
})));
export { SvgCheck24 as ReactComponent };